import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { Form, Col, Row, Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { object, string } from '../../../../Helpers/Validators/customValidators';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { SelectInput, TextInput } from '../../../../Helpers/Inputs';
import Money from '../../../../../icons/money-coins.svg';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import { withStyles } from '@material-ui/core/styles';
import { Slider } from "@material-ui/core";
import DigitalCoverageAmounts from '../../../../Helpers/Lists/CoverageAmounts/DigitalCoverageAmounts';
import NumberFormatDollars from '../../../../Helpers/Formatters/NumberFormatDollars';
import StyledRadioInput from '../../../../Helpers/Inputs/StyledRadioInput';
import { GetInflationBenefit, GetInterest, PremiumModesList, checkPiAgeIsMatchWithAgeLimit, insurancePolicyTypes } from '../../SubComponents/SelectOptions';
import GetYearList from '../../../../Helpers/Lists/YearList';
import TitleComponent from '../../../../Common/TitleComponent';
import { customValidators} from "../../../../Helpers/Validators/customValidators";

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

export default function ClientCoverage(props) {
    const isSurvivorshipPolicy = props.isSurvivorshipPolicy;
    const benefitDurationOptionMinYearValue = isSurvivorshipPolicy ? 4 : 2;

    const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
        validationSchema: ClientCoverage.ValidationSchema(props.basicInfo.pages, isSurvivorshipPolicy),
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    const handleValueChange = (field, value) => {
        setValue(field, value);
        props.onFieldChange(field, value);
        triggerValidation(field);
    };

    const onSubmit = () => {
        let fullForm = {...props.basicInfo}
        if(fullForm && fullForm.pages.quoter){
        fullForm.pages.quoter.coverageAmount= parseInt(props.formState.coverageAmount, 10);
        fullForm.pages.quoter.premiumMode= props.formState.premiumMode;
        fullForm.pages.quoter.benefitDuration = props.formState.benefitDuration;
        fullForm.pages.quoter.infBenefit = props.formState.infBenefit;
        fullForm.pages.quoter.interestRate = props.formState.interestRate;
        fullForm.pages.quoter.returnPremium= props.formState.returnPremium;
        props.onMultiFieldChange(fullForm);}
        props.onNext();
    }

    useEffect(() => {
        // manually register fields for validation that don't play nice with react-hook-form register
        register({ name: 'premiumMode' });
        setValue('premiumMode', props.formState.premiumMode);

        register({ name: 'benefitDuration' });
        setValue('benefitDuration', props.formState.benefitDuration);

        register({ name: 'infBenefit' });
        setValue('infBenefit', props.formState.infBenefit);

        register({ name: 'interestRate' });
        setValue('interestRate', props.formState.interestRate);

        register({ name: 'returnPremium' });
        setValue('returnPremium', props.formState.returnPremium);

    }, [register]);

    useEffect(() => {
        // Set benefitDuration to the default value when insurancePolicyTypes is Survivorship.
        if (isSurvivorshipPolicy && props.formState.benefitDuration === '') {
            setValue('benefitDuration', '86');
            props.onFieldChange('benefitDuration', '86');
        } 
    }, [isSurvivorshipPolicy]);

    return (
        <Container fluid className='border-class'>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className="justify-content-center pt-4 client-coverage">
                    <Col lg={4}>
                        <TitleComponent icon={Money} title="Your Client's Coverage" />
                        <div className="justify-content-center d-flex align-items-center mt-3 mb-1">
                            <div>Total Premium</div>
                            <Tooltip placement='top' id="riders-tooltip" title={"Amount of premium paid over the premium mode."} aria-describedby="riders-tooltip" aria-label="more about sort by price" className="toolInfo mt-0" role="tooltip" >
                                <LightTooltip>
                                    <button id="riders" role="tooltip" className="quote-tooltip" tabIndex="0" aria-disabled="true" aria-describedby="riders"><InfoIcon color="action"></InfoIcon></button>
                                </LightTooltip>
                            </Tooltip>
                        </div>

                        <Form.Group className='numberFormat mb-0'>
                            <TextInput
                                name="coverageAmount"
                                id="coverageAmount"
                                aria-label="Coverage Amount"
                                value={parseInt(props.formState.coverageAmount,10)}
                                errors={errors && errors.coverageAmount}
                                inputRef={register}
                                onChange={(e) =>handleValueChange("coverageAmount", e.target.value)}
                                variant="outlined"
                                InputProps={{
                                    inputComponent: NumberFormatDollars,
                                    className: 'text-decor',
                                }}
                            />
                        </Form.Group>

                        <Form.Group className="ml-3 mr-4 mb-2">
                        <Slider
                         min={0}
                         max={500000}
                         step={null}
                         value={props.formState.coverageAmount}
                         onChange={(e, v) =>handleValueChange("coverageAmount", v)}
                         className="m-2"
                         marks={DigitalCoverageAmounts(50000,500000,15000)}
                         role="slider"
                         aria-valuemin={50000}
                         aria-valuenow={parseInt(props.formState.coverageAmount, 10)}
                         aria-valuemax={500000}
                         aria-labelledby="coverageAmount"
                       />
                        </Form.Group>
                        <Row className="mb-2">
                            <Col md={11} className="pr-0">
                                <SelectInput
                                    name="infBenefit"
                                    id="infBenefit"
                                    value={props.formState.infBenefit}
                                    onChange={(e) => handleValueChange('infBenefit', e.target.value)}
                                    label="Inflation Benefit Option"
                                    selectOptions={GetInflationBenefit(isSurvivorshipPolicy)}
                                    errors={errors.infBenefit}
                                    inputRef={register}
                                />
                            </Col>
                            <Col md={1} className="pr-0 pl-0 mt-2">
                                <Tooltip placement='top' id="riders-tooltip" title={"Increase the monthly Premium benefit by the selected percentage on each policy anniversary."} aria-describedby="riders-tooltip" aria-label="more about sort by price" className="toolInfo mt-1 pt-1" role="tooltip" >
                                    <LightTooltip>
                                        <button id="riders" role="tooltip" className="quote-tooltip" tabIndex="0" aria-disabled="true" aria-describedby="riders"><InfoIcon color="action"></InfoIcon></button>
                                    </LightTooltip>
                                </Tooltip>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col md={11} className="pr-0">
                                <SelectInput
                                    name="benefitDuration"
                                    id="benefitDuration"
                                    value={props.formState.benefitDuration}
                                    onChange={(e) => handleValueChange('benefitDuration', e.target.value)}
                                    label={isSurvivorshipPolicy ? "Joint Benefit Duration" : "Benefit Duration"}
                                    selectOptions={GetYearList(benefitDurationOptionMinYearValue, 8, isSurvivorshipPolicy)}
                                    errors={errors.benefitDuration}
                                    inputRef={register}
                                />
                            </Col>
                            <Col md={1} className="pr-0 pl-0 mt-2">
                                <Tooltip placement='top' id="riders-tooltip" title={"Elected duration when benefits will be paid."} aria-describedby="riders-tooltip" aria-label="more about sort by price" className="toolInfo mt-1 pt-1" role="tooltip" >
                                    <LightTooltip>
                                        <button id="riders" role="tooltip" className="quote-tooltip" tabIndex="0" aria-disabled="true" aria-describedby="riders"><InfoIcon color="action"></InfoIcon></button>
                                    </LightTooltip>
                                </Tooltip>
                            </Col>
                        </Row>
                        <Row className="mt-2 mb-2">
                            <Col md={11} className="pr-0">
                                <SelectInput
                                    name="premiumMode"
                                    id="premiumMode"
                                    value={props.formState.premiumMode}
                                    onChange={(e) => handleValueChange('premiumMode', e.target.value)}
                                    label="Premium Mode"
                                    selectOptions={PremiumModesList(isSurvivorshipPolicy)}
                                    errors={errors.premiumMode}
                                    inputRef={register}
                                />
                            </Col>
                            <Col md={1} className="pr-0 pl-0 mt-2">
                                <Tooltip placement='top' id="riders-tooltip" title={"Time period when total Premium amount will be paid."} aria-describedby="riders-tooltip" aria-label="more about sort by price" className="toolInfo mt-1 pt-1" role="tooltip" >
                                    <LightTooltip>
                                        <button id="riders" role="tooltip" className="quote-tooltip" tabIndex="0" aria-disabled="true" aria-describedby="riders"><InfoIcon color="action"></InfoIcon></button>
                                    </LightTooltip>
                                </Tooltip>
                            </Col>
                        </Row>
                        <Row className="mt-2 mb-2">
                            <Col md={11} className="pr-0">
                                <SelectInput
                                    name="interestRate"
                                    id="interestRate"
                                    value={props.formState.interestRate}
                                    onChange={(e) => handleValueChange('interestRate', e.target.value)}
                                    label="Assumed Interest Rate*"
                                    selectOptions={GetInterest}
                                    errors={errors.interestRate}
                                    inputRef={register}
                                />
                            </Col>
                            <Col md={1} className="pr-0 pl-0 mt-2">
                                <Tooltip placement='top' id="riders-tooltip" title={"The Assumed Market Interest Rate is the selected rate of return that policy investments are being projected to earn prior to any charges or fees being assessed."} aria-describedby="riders-tooltip" aria-label="more about sort by price" className="toolInfo mt-1 pt-1" role="tooltip" >
                                    <LightTooltip>
                                        <button id="riders" role="tooltip" className="quote-tooltip" tabIndex="0" aria-disabled="true" aria-describedby="riders"><InfoIcon color="action"></InfoIcon></button>
                                    </LightTooltip>
                                </Tooltip>
                            </Col>
                        </Row>
                        <Row className="justify-content-between ml-0">
                            <Col md={11} className="px-0">
                                <h6 className='pt-2'>Return of premium?</h6>
                            </Col>
                            <Col md={1} className="px-0 mt-2">
                                <span className="pt-1">
                                    <Tooltip placement='top' id="riders-tooltip" title={"The Assumed Market Interest Rate is the selected rate of return that policy investments are being projected to earn prior to any charges or fees being assessed."}>
                                        <LightTooltip >
                                            <button id="riders" role="tooltip" className="quote-tooltip" tabIndex="0" aria-disabled="true" aria-describedby="riders"><InfoIcon color="action"></InfoIcon></button>
                                        </LightTooltip>
                                    </Tooltip>
                                </span>
                            </Col>
                        </Row>
                        <Row className="mt-2 mb-2">
                            <Col md={11} className="pr-0">
                                <Form.Group>
                                    <StyledRadioInput
                                        name="returnPremium"
                                        id="returnPremium"
                                        label=""
                                        value={props.formState.returnPremium}
                                        options={[{ value: true, label: "Yes" }, { value: false, label: "No" }]}
                                        onChange={e => handleValueChange('returnPremium', e)}
                                        errors={errors.returnPremium}
                                        labelCenter={true}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="pt-5 mb-4 mx-2">
                    <Col className="text-left btn-back">
                        <Button variant="outlined" size="medium" color="primary" onClick={props.onBack}>BACK</Button>
                    </Col>
                    <Col className="text-right">
                        <Button variant="contained" size="medium" color="primary" type="submit">NEXT</Button>
                    </Col>
                </Row>
            </Form>
        </Container>
    );
}

ClientCoverage.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
};

ClientCoverage.DefaultFormState = (prefill) => {
    return {
        coverageAmount: prefill ? 200000 : 50000,
        premiumMode: prefill ? '5 Pay' : '',
        benefitDuration: prefill ? '4 Years' : '',
        infBenefit: prefill ? 'No Inflation' : '',
        interestRate: prefill ? '6%' : '',
        returnPremium: prefill ? false : '',
    };
};

ClientCoverage.ValidationSchema = (state, isSurvivorshipPolicyType) => {
    return object().shape({
        premiumMode: string().required('Premium Mode is required.')
            .test({
                message: (premiumMode) => {
                    return `${premiumMode.value} premium mode issue age range is 30 - 65 years.`;
                },
                test: (value) => checkPiAgeIsMatchWithAgeLimit(value, state, isSurvivorshipPolicyType)
            }),
        coverageAmount: customValidators.string()
            .isValidCoverageAmountString('Please verify your value has been entered correctly.', 0, 500000),
        benefitDuration: string().required(`${isSurvivorshipPolicyType ? 'Joint Benefit' : 'Benefit'} Duration is required.`),
        infBenefit: string().required('Inflation Benefit is required.'),
        interestRate: string().required('Interest Rate is required.'),
        returnPremium: string().required('Return of Premium is required.'),
    })
}



// WEBPACK FOOTER //
// ./src/components/Product/ABLTC/RequestIllustration/Steps/ClientCoverage.js